'use strict';

/**
 *
 * @name: nsSocialButton
 *
 */

import DirectiveTemplate from './nn-social-button.directive.html';
import './nn-social-button.directive.scss';

function NsSocialButtonDirective(rootAnalytics, $sce) {

  'ngInject';

  return {
    restrict: 'EA',
    replace: true,
    template: DirectiveTemplate,
    scope: {
      socialName: '@',
      socialGa: '@'
    },
    link: function(scope, $element) {
      scope.facebookLikeCode = $sce.trustAsResourceUrl(`//www.facebook.com/plugins/like.php?href=http%3A%2F%2Ffacebook.com%2F${scope.$root.facebookSite[scope.$root.lang]}%23_yJmh6Vd365O&send=false&layout=button&width=88&show_faces=false&action=like&colorscheme=light&font&height=21`)
      scope.twitterLikeCode = $sce.trustAsResourceUrl(`//platform.twitter.com/widgets/follow_button.450bd5fbaeab74caf9d49a3141d20693.en.html#_=1445524774154&dnt=false&id=twitter-widget-1&lang=en&screen_name=${scope.$root.twitterSite[scope.$root.lang]}&show_count=false&show_screen_name=false&size=m`)

      setTimeout(function() {

        // Render google buttons
        if (scope.socialName === 'youtube') {
          gapi.ytsubscribe.go();
        }
        if (scope.socialName === 'googleplus') {
          gapi.follow.go();
        }
        $element.find('iframe').iframeTracker({
          blurCallback: function() {

            rootAnalytics.socialNetwork(scope.socialGa, scope.socialName);
          }
        });
      }, 888);
    }
  };
}

export default NsSocialButtonDirective;



// WEBPACK FOOTER //
// ./app/components/nn-social/nn-social-button/nn-social-button.directive.js